import React from "react";
import PropTypes from "prop-types";
import styles from './FormGroupSelect.module.scss';
import { FormGroup, Label, Select } from "components/formElements";

const FormGroupSelect = ({ id, label, options, selectRef, ...rest }) => (
  <FormGroup className={`${styles.formGroupSelect} ${id === "noticePeriod" ? styles.noticePeriodSelect : ''}`}>
    <Select id={id} options={options} selectRef={selectRef} {...rest} />
    {/* <Label htmlFor={id} label={label} /> */}
    {id === "noticePeriod" ? <Label htmlFor={id} label={label} id={id}/> : null}
  </FormGroup>
);

FormGroupSelect.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export { FormGroupSelect };
